//@ts-nocheck
import React from "react";
import SVGFactory, { SVGName } from "../../../svgFactory";
import Title from "../Title/Title";
import "./Header.css";

const Header = () => {
  const titleStyle = {
    fontFamily: "STIXGeneral",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "20px",
    textAlign: "center",
    color: "#093872",
    marginTop: "18%",
  };
  const title2Style = {
    fontFamily: "STIXGeneral",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "18px",
    textAlign: "center",
    color: "#093872",
  };
  const subTitleStyle = {
    fontFamily: "DIN",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "15px",
    textAlign: "center",
    color: "#000000",
    marginTop: 14,
  };
  const subTitleJSXStyle = {
    fontFamily: "DIN",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "18px",
    textAlign: "center",
    color: "#000000",
  };
  return (
    <div className="bik-sm-header">
      <SVGFactory name={SVGName.BRAND} />
      <SVGFactory name={SVGName.GET_VACATION_READY} />
      <SVGFactory name={SVGName.TRAVEL_IN_STYLE} />

      <Title
        subTitle1JSX={
          <>
            <p style={subTitleJSXStyle}>
              Spin the Wheel and Win Assured Gifts{" "}
              <SVGFactory name={SVGName.GIFT_SMALL} />
            </p>
            <p style={subTitleJSXStyle}>from Shoppers Stop</p>
          </>
        }
        titleStyle={titleStyle}
        subTitleStyle={subTitleStyle}
        title2Style={title2Style}
      />
    </div>
  );
};
export default Header;
